
  
 import React, { useState } from 'react';
 import PlanAndPrice from './PlanAndPrice'
 import FixPrice from './FixPrice'
 import StartupPricingPage from './StartupPricingPage'

const Docs = () => {
  const [activeTab, setActiveTab] = useState('test');
  const [collapsed, setCollapsed] = useState(true);

  const tabs = [
    { key: 'test', label: 'Test Account', icon: '👤' },
    { key: 'testCard', label: 'Test Card', icon: '💳' },
    { key: 'price', label: 'Plan & Price', icon: '💰' },
    { key: 'video', label: 'Product Video', icon: '🎥' },
    { key: 'order', label: 'How to Order', icon: '🛒' },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'test':
        return (
          <div style={styles.card}>
            <h2>👤 Test Accounts</h2>
            <ul>
              <li><strong>User:</strong> testuser@test.com / T35tUs3@</li>
              <li><strong>Admin:</strong> testadmin@test.com / D0no1M#35s</li>
            </ul>
          </div>
        );
      case 'testCard':
        return (
          <>
            <div style={styles.card}>
              <h2>💳 Stripe Test Card</h2>
              <ul>
                <li><strong>Card:</strong> 4242 4242 4242 4242</li>
                <li><strong>Expiry:</strong> 04/30</li>
                <li><strong>CVC:</strong> 123</li>
                <li><strong>Postcode:</strong> EC1A 1BB</li>
              </ul>
            </div>
            <div style={styles.card}>
              <h2>❌ Declined Cards</h2>
              <ul>
                <li>4000 0000 0000 0002 - Declined</li>
                <li>4000 0000 0000 9995 - Insufficient Funds</li>
                <li>4000 0000 0000 0069 - Expired</li>
                <li>4000 0000 0000 0127 - Incorrect CVC</li>
              </ul>
            </div>
          </>
        );
      case 'price':
        return <div style={styles.card}><h2>💰 Plan & Pricing</h2>
               
               <div><StartupPricingPage/></div>
               <div><FixPrice/></div>
             
               </div>;
      case 'video':
        return <div style={styles.card}><h2>🎥 Product Video</h2><p>Video content coming soon.</p></div>;
      case 'order':
        return <div style={styles.card}><h2>🛒 How to Order</h2><p>Instructions go here.</p></div>;
      default:
        return null;
    }
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.sidebar,
          width: collapsed ? 60 : 220,
          flexDirection: collapsed ? 'column' : 'column',
        }}
      >
        <button style={styles.toggleBtn} onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? '☰' : '×'}
        </button>

        {tabs.map(({ key, label, icon }) => (
          <div
            key={key}
            onClick={() => setActiveTab(key)}
            style={{
              ...styles.navItem,
              backgroundColor: activeTab === key ? '#334155' : 'transparent',
              color: activeTab === key ? 'white' : '#cbd5e1',
              writingMode: collapsed ? 'vertical-rl' : 'horizontal-tb',
              textAlign: collapsed ? 'center' : 'left',
              padding: collapsed ? '10px 5px' : '10px 15px',
              whiteSpace: collapsed ? 'nowrap' : 'normal',
              overflow: 'hidden',
            }}
          >
            <span style={styles.icon}>{icon}</span>
            {!collapsed && <span>{label}</span>}
          </div>
        ))}
      </div>

      <div style={styles.content}>
        {renderContent()}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '100vh',
    fontFamily: 'Segoe UI, sans-serif',
    backgroundColor: '#f9fafb',
  },
  sidebar: {
    backgroundColor: '#1f2937',
    color: 'white',
    transition: 'width 0.3s ease',
    overflowX: 'hidden',
  },
  toggleBtn: {
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: 22,
    padding: 10,
    cursor: 'pointer',
    alignSelf: 'flex-end',
  },
  navItem: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    borderBottom: '1px solid #334155',
    transition: 'all 0.2s',
  },
  icon: {
    fontSize: 18,
    marginRight: 10,
  },
  content: {
    flex: 1,
    padding: '2rem',
  },
  card: {
    backgroundColor: 'white',
    padding: '1.5rem',
    borderRadius: '12px',
    marginBottom: '1rem',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  },
};

export default Docs;
 
  


